import { Route } from '@angular/router';

export const kanziAuthRfidRoutes: Route[] = [
  { path: '', redirectTo: '/auth/login', pathMatch: 'full' },
  {
    path: 'login',
    loadComponent: () =>
      import('./pages/login-rfid/login-rfid.component').then(
        (m) => m.LoginRfidComponent
      ),
  },
];
